"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenu = void 0;
let $ = require("jquery");
require("@progress/kendo-ui");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const Utilities_1 = require("../../javascript/Utilities");
const CommandLayout_1 = require("../Menu/CommandLayout");
const MethodManager_1 = require("../Menu/MethodManager");
class ContextMenu {
    constructor() {
        this.m_contextMenuId = "contextMenu_" + Utilities_1.synUtil.getGUID(true);
    }
    get contextMenuId() {
        return this.m_contextMenuId;
    }
    openAsync(eventObjectContextMenu, commandLayouts, commandTriggerTarget) {
        const that = this;
        return new Promise((resolve) => {
            // ev. vorheriges ContextMenu löschen
            that.destroy();
            // Das appContainer-div ist der geeignete Parent für das Contextmenu in Bezug auf Sichtbarkeit und Anzeige von Scrollbars
            const menuVerticalSpacing = 20;
            let $elementForData = $(eventObjectContextMenu.currentTarget);
            // Für sehr lange ContextMenüs muss hier die maximale Höhe (und eigentlich das scrolling) gesetzt werden - kendoContextMenu macht das offenbar bei der ersten Ebene leider nicht automatisch!
            let $appContainer = $(".appContainer");
            let maxContextMenuHeight = $appContainer.innerHeight() - 2 * menuVerticalSpacing /* allow some space around menu*/;
            let $menuControl = $("<ul></ul>")
                .attr("id", that.contextMenuId)
                .css({
                "max-height": Math.floor(maxContextMenuHeight).toString() + "px",
                "max-width": "450px",
                "box-sizing": "border-box",
                "overflow-y": "auto",
                "margin-top": Math.ceil(-menuVerticalSpacing).toString() + "px",
                "margin-bottom": Math.floor(menuVerticalSpacing).toString() + "px"
            })
                .appendTo($elementForData);
            let menuDataSource = commandLayouts.GetDataSource(CommandLayout_1.MenuType.ContextMenu);
            menuDataSource.fetch(function () {
                // Jetzt das neue ContextMenu aufbauen
                $menuControl.trigger("beginInit");
                $menuControl.addClass("synContextMenu");
                if (Utilities_1.synUtil.isHDScreen)
                    $menuControl.addClass('HDScreen');
                $menuControl.kendoContextMenu({
                    animation: false,
                    dataSource: this._pristineData,
                    orientation: "vertical",
                    closeOnClick: true,
                    showOn: "",
                    target: $elementForData,
                    alignToAnchor: true,
                    close: (e) => {
                        var _a;
                        // There is a special case where a mousedown event on the scroll bar of an overly long context 
                        // menu results in the context menu being closed instead of scrolling. This code checks if the
                        // mousedown event was triggered above the scroll bar, and if so, cancels the close event,
                        // allowing the user to scroll the context menu via clicking/dragging on the scrollbar.
                        const $ctxBody = that.getContextMenuBody();
                        if ("mousedown" === ((_a = e.event) === null || _a === void 0 ? void 0 : _a.type) && $ctxBody.is(e.event.target)) {
                            // cf. developer.mozilla.org/en-US/docs/Web/API/Element/clientWidth for why it works
                            if ($ctxBody.prop("clientWidth") <= e.event.offsetX)
                                e.preventDefault();
                        }
                    },
                    select: (e) => {
                        let dataSource = e.sender.options.dataSource;
                        let menuEntry = that.getDataItem($(e.item), dataSource);
                        if (menuEntry)
                            MethodManager_1.MethodManager.executeMethodForMenu(menuEntry, commandLayouts, $menuControl, commandTriggerTarget);
                    },
                });
                $menuControl.trigger("initSuccess");
                $menuControl.trigger("endInit");
                let contextMenu = $menuControl.data("kendoContextMenu");
                contextMenu.open(eventObjectContextMenu.clientX, eventObjectContextMenu.clientY);
                resolve();
            });
        });
    }
    destroy() {
        this.getContextMenuAnimationContainer().remove();
    }
    getContextMenuBody() {
        return $("#" + this.m_contextMenuId);
    }
    getContextMenuAnimationContainer() {
        const $ctxBody = this.getContextMenuBody();
        let $animationContainer = $();
        if ($ctxBody.length) {
            // .k-popups-wrapper.vertical wird erzeugt, wenn bei LANGEN ContextMenüs Scrollbars erzeugt werden müssen
            $animationContainer = $ctxBody.parents(".k-popups-wrapper.vertical");
            if (!$animationContainer.length) // Keine Scrollbars notwendig
                $animationContainer = $ctxBody.parent(".k-animation-container");
        }
        return $animationContainer;
    }
    // getDataItem ermittelt den menuEntry von dataSource ausgehend aus dem domItem des Menü-Items, das der Benutzer ausgewählt hat
    // Dieser Sourcecode wurde von Menu.ts übernommen.
    getDataItem(domItem, dataSource) {
        let menuElement = domItem.closest(".k-menu");
        let dataItem = dataSource;
        let index = domItem.parentsUntil(menuElement, ".k-item").map(function () {
            return $(this).index();
        }).get().reverse();
        index.push(domItem.index());
        for (let i = -1, len = index.length; ++i < len;) {
            dataItem = dataItem[index[i]];
            dataItem = i < len - 1 ? dataItem.items : dataItem;
        }
        return dataItem;
    }
}
exports.ContextMenu = ContextMenu;
